import type { ArgumentsType } from '@vueuse/core';
import { readonly, ref, type Ref } from 'vue';

export function useAtomic<T extends (...args: never[]) => Promise<unknown>, Err = string>(callable: T) {
  const running = ref<null | Promise<unknown>>(null);
  const error = ref<null | Err>(null);
  const exec = (...args: ArgumentsType<T>) => {
    if (running.value) return running.value;
    error.value = null;
    const future = callable(...args);
    running.value = future;
    future.catch((err) => (error.value = err));
    future.finally(() => (running.value = null));
    return future;
  };

  return [exec, readonly(running), error] as [T, Ref<null | ReturnType<T>>, Ref<Err | null>];
}
